import { PricingItem } from "./PricingItem";
import { pricingList } from "./pricingList";
import "./PricingBlock.css";
import { useMobileContext } from "context/MobileContext";
import PricingTable from "./PricingTable";

const PricingBlock = () => {
  const { isMobile } = useMobileContext();
  return (
    <section className="pricing-block">
      {isMobile ? (
        pricingList.map((item) => <PricingItem {...item} />)
      ) : (
        <PricingTable />
      )}
    </section>
  );
};

export default PricingBlock;
